import { CountBadge } from '@europrocurement/flexy-components';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import { useWebsocketActions, useWebsocketState } from '@europrocurement/l2d-websocket';
import React, { useEffect, useMemo } from 'react';

export const CounterTabNotification: React.FunctionComponent<{
    dossier: DossierOpenSearch | undefined;
}> = function ({ dossier }) {
    const topicId = useMemo(
        () => (dossier?.id ? `messagerie_dossier_formalite_${dossier.id}` : null),
        [dossier?.id],
    );

    const { socketOpen, unreadCountByTopic } = useWebsocketState();
    const { getMessageCount } = useWebsocketActions();

    useEffect(() => {
        if (socketOpen && topicId) {
            getMessageCount(topicId);
        }
    }, [socketOpen, topicId, getMessageCount]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (topicId && socketOpen) {
                getMessageCount(topicId);
            }
        }, 20000);

        return () => {
            clearInterval(interval);
        };
    }, [topicId, socketOpen, getMessageCount]);

    return (
        <CountBadge
            count={topicId && unreadCountByTopic[topicId] ? unreadCountByTopic[topicId] : 0}
            color="primary"
            bgVariant="light"
        />
    );
};

export default CounterTabNotification;
